import { useMemo } from 'react';
import { useTrainingApiProvider, useTrainingStorage } from '../api';
import { TrainingService } from './trainingService';

export const useTrainingService = () => {
  const api = useTrainingApiProvider();
  const storage = useTrainingStorage();
  return useMemo(() => new TrainingService(api, storage), [api, storage]);
};
